import { LitElement, html, css, utils } from '@hh/global.js'

class HHAnnouncementBar extends LitElement {
  static properties = {
    closed: {
      type: Boolean,
      reflect: true,
    },
    sessionStorageKey: {
      type: String,
    },
    textContent: {
      type: Object,
    },
    textContentWidth: {
      type: Number,
    },
    marqueeSpeed: {
      type: Number,
      reflect: true,
    },
    isMarquee: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
    this.sessionStorageKey = 'announcementBarClosed'
    this.closed = sessionStorage.getItem(this.sessionStorageKey) === 'true'
    this.marqueeSpeed = this.marqueeSpeed
  }

  connectedCallback() {
    super.connectedCallback()
    window.addEventListener('resize', this.updateMarquee.bind(this))
    this.textContent = utils.one('[data-content]')
    this.isMarquee = false
    this.marquee = null
  }

  setHeaderOffsetVariable(element = this.parentElement.parentElement) {
    document.documentElement.style.setProperty(
      '--header-height',
      `${element.offsetHeight * 0.1}rem`
    )
  }

  firstUpdated() {
    this.textContentWidth = this.textContent.getBoundingClientRect().width
    this.marquee = utils.one('hh-marquee', this.renderRoot)
    this.marquee.stopped = true
    this.updateMarquee()
    this.setHeaderOffsetVariable()
  }

  onClose() {
    this.closed = true
    sessionStorage.setItem(this.sessionStorageKey, this.closed)
    this.setHeaderOffsetVariable(this.parentElement.nextElementSibling)
  }

  updateMarquee() {
    this.isMarquee =
      this.textContentWidth > this.getBoundingClientRect().width - 60
    this.marquee.stopped = !this.isMarquee
  }

  render() {
    return html`
      <slot name="text-content"></slot>

      <slot name="link"></slot>

      <hh-marquee speed="${this.marqueeSpeed}">
        ${this.textContent.cloneNode(true)}
      </hh-marquee>

      <slot name="close" @click="${this.onClose}"></slot>
    `
  }

  static styles = css`
    :host([closed]) {
      display: none;
    }

    :host hh-marquee {
      display: none;
    }

    :host([ismarquee]) slot[name='text-content'] {
      display: none;
    }

    :host([ismarquee]) hh-marquee {
      display: block;
    }
  `
}

customElements.define('hh-announcement-bar', HHAnnouncementBar)
